const MAX_NUMBERS = 15;

export function calcQuantitySelectorAmounts(step: number = 1) {
  const amounts: number[] = [];
  const stepOverHundred = step === 10 ? 50 : step;

  for (
    let i = 0;
    amounts.length < MAX_NUMBERS;
    i += i < 100 ? step : stepOverHundred
  ) {
    amounts.push(i);
  }

  return amounts;
}
